import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Responsabilities from '@/view/record/responsabilities/Responsabilities'

export default {
  path: '/responsabilities',
  name: 'Responsabilities',
  components: {
    default: Responsabilities,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'Responsabilidades' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/ResponsabilitiesRoute.js